module.exports = __webpack_public_path__ + "static/img/bf-btn-on.130b02a9.png";